import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, IconButton, InputAdornment, Autocomplete, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { addDoc, collection, doc, getDocs, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { db } from '../../../firebase.config';
import { UserAuth } from '../../../context/AuthContext';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import PasswordValidation from '../../../pages/crm/component/passwordValidation';
import LucideIcon from '../../../components/LucideIcon';

// ----------------------------------------------------------------------

export default function RegisterForm() {
  const { user, signUp, signUpSecondStep } = UserAuth();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  const RegisterSchema = Yup.object().shape({
    firstName: Yup.string().required('Nom est obligatoire'),
    lastName: Yup.string().required('Prénom est obliagtoire'),
    email: Yup.string().email('Email doit est être un email valide').required('Email est obligatoire'),
    password: Yup.string().required('Mot de passe est obligatoire'),
    confirmedPassword: Yup.string().required('Mot de passe est obligatoire'),
  });

  const defaultValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmedPassword: '',
  };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });



  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = methods;
  const passwordValue = watch('password');
  const isPasswordValid = (password) => (
    /[a-z]/.test(password) &&       // minuscule
    /[A-Z]/.test(password) &&       // majuscule
    /[0-9]/.test(password) &&       // chiffre
    /[!@#$%^&*(),.?":{}|<>]/.test(password) && // spécial
    password.length >= 8            // longueur
  );
  const onSubmit = async (e) => {
    try {
      if (!isPasswordValid(e.password)) {
        setError('Le mot de passe ne respecte pas les critères de sécurité.');
        return;
      }
      if (e.password === e.confirmedPassword) {
        const reg = await signUp(e.email, e.password);
        // create organisation
        console.log(reg.user.uid)
        // create user
        const newUserRef = doc(db, "users", reg.user.uid);
        await setDoc(newUserRef, {
          id: reg.user.uid,
          uid: reg.user.uid,
          dateCreation: serverTimestamp(),
          email: e.email.trim(),
          isOrg: true,
          nom: e.lastName.trim(),
          prenom: e.firstName.trim()
        });
        if (redirect) {
          navigate(redirect, { replace: true });
        } else {
          navigate('/register/organisation', { replace: true });
        }

        console.log(user.uid)
      } else {
        setError('Le mot de passe ne correspond pas');
      }

    } catch (error) {
      console.log('erro');
      setError(error.message);
      console.log(error.message);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField name="lastName" label="Nom" placeHolder={'votre nom'} startIcon={<LucideIcon name='User' size={18} />} />
          <RHFTextField name="firstName" label="Prénom" placeHolder={'votre prénom'} startIcon={<LucideIcon name='User' size={18} />} />
        </Stack>

        <RHFTextField name="email" label="Email" placeHolder={'exemple@email.com'} startIcon={<LucideIcon name='Mail' size={18} />} />

        <RHFTextField
          name="password"
          label="Mot de passe"
          placeHolder={'*******'}
          type={showPassword ? 'text' : 'password'}
          startIcon={<LucideIcon name='Lock' size={18} />}
          endIcon={<IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
          </IconButton>}
        />
        {error && <PasswordValidation password={passwordValue} />}
        
        <RHFTextField
          name="confirmedPassword"
          label="Confirmation mot de passe"
          placeHolder={'*******'}
          type={showCPassword ? 'text' : 'password'}
          startIcon={<LucideIcon name='Lock' size={18} />}
          endIcon={<IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
          </IconButton>}
        />

        <LoadingButton sx={{
              textTransform: 'initial',
              border: '2px solid transparent',
              color: 'white',
              paddingLeft: 5,
              paddingRight: 5,
              backgroundColor: '#5E17EB',
              borderRadius: '7px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#A47CF4',
                color: 'white',
                borderColor: '#A47CF4',
              },
            }} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Inscription
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
